export const VERIFY_EMAIL_SESSION_STORAGE_KEY = 'wl-verify-email-session:v1';

export type VerifyEmailPersistedState = 'already_confirmed' | 'confirmed';

export interface VerifyEmailPersistedSession {
  emailMasked: string | null;
  state: VerifyEmailPersistedState;
}

const isVerifyEmailPersistedState = (value: unknown): value is VerifyEmailPersistedState => {
  return value === 'already_confirmed' || value === 'confirmed';
};

export const clearVerifyEmailSession = (): void => {
  try {
    sessionStorage.removeItem(VERIFY_EMAIL_SESSION_STORAGE_KEY);
  } catch {
    return;
  }
};

export const getVerifyEmailSession = (): VerifyEmailPersistedSession | null => {
  try {
    const rawValue = sessionStorage.getItem(VERIFY_EMAIL_SESSION_STORAGE_KEY);

    if (!rawValue) return null;

    const parsed: unknown = JSON.parse(rawValue);

    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;

    const record = parsed as Record<string, unknown>;

    if (!isVerifyEmailPersistedState(record.state)) return null;

    if (record.emailMasked !== null && typeof record.emailMasked !== 'string') return null;

    return {
      emailMasked: record.emailMasked ?? null,
      state: record.state
    };
  } catch {
    return null;
  }
};

export const saveVerifyEmailSession = (session: VerifyEmailPersistedSession): void => {
  try {
    sessionStorage.setItem(VERIFY_EMAIL_SESSION_STORAGE_KEY, JSON.stringify({
      emailMasked: session.emailMasked,
      state: session.state
    }));
  } catch {
    return;
  }
};